import React from "react";
import { ConfirmationModalContainer } from "../Modal/ConfirmationModalContainer";
import { KeyValueList } from "../KeyValueList";

interface Props {
  open: boolean;
  onClose: () => unknown;
  selectedAudeinceValue: string;
  selectedAudineceCategory: string;
  onConfirmSendNotifications: () => unknown;
  title: string;
  text: string;
}
export const SendNotificationConfirmationModal = ({
  open,
  onClose,
  selectedAudeinceValue,
  selectedAudineceCategory,
  onConfirmSendNotifications,
  title,
  text,
}: Props) => {
  return (
    <ConfirmationModalContainer
      show={open}
      onClose={onClose}
      isProcessingConfirmation={false}
      onSubmit={onConfirmSendNotifications}
      submitButtonText="Send"
    >
      <div className="flex flex-col justify-center items-center gap-2">
        <h2>Are you sure you want to send this notification?</h2>
        <KeyValueList
          lists={[
            { key: "Title", value: title },
            { key: "Body", value: text },
            { key: "Audience", value: selectedAudeinceValue },
            {
              key: "Category",
              value: selectedAudineceCategory,
            },
          ]}
        />
      </div>
    </ConfirmationModalContainer>
  );
};
